import { fork } from 'redux-saga/effects';
import { filtersConfigWatcher } from './filtersSaga';
import { ordersConfigWatcher } from './ordersSagas';
import { orderCardConfigWatcher } from './orderCardSaga';
import { mailConfigWatcher } from './mailSagas';

export default function* Orders() {
  yield fork(ordersConfigWatcher);
  yield fork(orderCardConfigWatcher);
  yield fork(filtersConfigWatcher);
  yield fork(mailConfigWatcher);
}
